import { render, staticRenderFns } from "./unlistedUniversities.vue?vue&type=template&id=333bd956&"
import script from "./unlistedUniversities.vue?vue&type=script&lang=js&"
export * from "./unlistedUniversities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports